import { http } from './config'

export default {
  login: (data) => {
    return http.post('user/login', data)
  },
  ranking: (data) => {
    console.log(data)
    return http.post('dashboard/ranking', data)
  },
  analiseLiberacao: (data) => {
    return http.post('dashboard/analiseLiberacao', data)
  },
  listarCidades: () => {
    return http.get('dashboard/cidades')
  },
  listarEmpresas: () => {
    return http.get('dashboard/empresas')
  },
  listarConvenios: (data) => {
    return http.post('dashboard/convenios', data)
  },
  listarUnidadesProcessamento: () => {
    return http.get('dashboard/unidadesProcessamento')
  },
  listarUnidades: (data) => {
    console.log(data)
    return http.post('dashboard/unidadesSolicitantes', data)
  },
  buscarUnidades: () => {
    return http.get('dashboard/unidades')
  },
  listarestatisticasAnoMes: (anos, dia) => {
    return http.post('dashboard/estatisticaMesAno', { anos: anos, dia: dia })
  },
  estatisticaHora: (data) => {
    return http.post('dashboard/estatisticaHora', data)
  },
  osLiberacaoPendente: (data) => {
    return http.post('dashboard/osLiberacaoPendente', data)
  }
}
